const axios = require("axios");
const config = require("./config");
const helpers = require("../../helpers");
const instance = axios.create({
    baseURL: config.baseURL,
    timeout: config.timeout,
});

const loadAll = ({ href = "", filter = {} }) => {
    let p = new Promise((resolve) => {
        instance.post(href, filter).then((res) => {
            if (res.status === 200) resolve(res.data);
            else resolve({ error: res });
        }).catch((error) => {
            console.log(error);
            resolve({ error });
        });
    });

    return p;
};

module.exports = {
    login: (filter) => loadAll({ href: "/authen/login", filter }),
    logout: (filter) => loadAll({ href: "/authen/logout", filter }),
    register: (filter) => loadAll({ href: "/authen/register", filter }),
    activate: (filter) => loadAll({ href: "/authen/activate", filter }),
    password: {
        forgot: (filter) => loadAll({ href: "/authen/password/forgot", filter }),
        reset: (filter) => loadAll({ href: "/authen/password/reset", filter }),
    },
    upload: (filter) => loadAll({ href: "/upload", filter }),
    ranking: {
        count: (filter) => loadAll({ href: "/ranking/count", filter }),
        results: (filter) => loadAll({ href: "/ranking/results", filter }),
        update: (filter) => loadAll({ href: "/ranking/update", filter }),
    },
    seo: {
        project: (filter) => loadAll({ href: "/seo/project", filter })
    },
    socket: {
        emit: (filter) => loadAll({ href: "/socket/emit", filter }),
        list: () => loadAll({ href: "/socket/list" }),
    },
    file: {
        metadata: {
            write: (filter) => loadAll({ href: "/file/metadata/write", filter }),
        },
    },
    excel: {
        read: (filter) => loadAll({ href: "/excel/read", filter }),
    },
    qrcode: {
        create: (filter) => loadAll({ href: "/qrcode/create", filter }),
    },
};
// export const login = (filter) => loadAll({ href: "/authen/login", filter });



// WEBPACK FOOTER //
// src/utils/api/node/api.node.origin.js